export default __webpack_public_path__ + "static/media/Group 607.86db0c14.png";